const commonReducerDefaultState = {
    navCategory: "",
    // feedInfo: "",
    socialList: [],
    shareNetworks: [],
    ttsVoiceURI: localStorage.getItem('ttsVoiceURI') || '',
    ttsVolume: parseFloat(localStorage.getItem('ttsVolume') ?? '1'),
    ttsRate: 1,
    ttsVoices: [],
    ttsActiveId: null,
    ttsPaused: false,
};

export default (state = commonReducerDefaultState, action) => {
    // console.log("COMMON",action.type)
    switch (action.type) {
        case 'LOGOUT':
            return {
                ...commonReducerDefaultState
            };
        case 'SET_NAV_CATEGORY':
            return {
                ...state,
                ...action.navCategory,
            };
        case 'SET_SHARE_LIST':
            return {
                ...state,
                socialList: action.list,
            };
        case 'SET_SHARE_NETWORKS':
            return {
                ...state,
                shareNetworks: action.list,
            };
        case 'SET_TTS_VOICE':
            return {
                ...state,
                ttsVoiceURI: action.voiceURI,
            };
        case 'SET_TTS_VOICES':
            return {
                ...state,
                ttsVoices: action.voices,
            };
        case 'SET_TTS_VOLUME':
            return {
                ...state,
                ttsVolume: action.volume,
            };
        case 'SET_TTS_RATE':
            return {
                ...state,
                ttsRate: action.rate,
            };
        case 'SET_TTS_ACTIVE_ID':
            return {
                ...state,
                ttsActiveId: action.id,
                ttsPaused: false,
            };
        case 'PAUSE_TTS':
            return {
                ...state,
                ttsPaused: true,
            };
        case 'TOGGLE_TTS':
            return {
                ...state,
                ttsActiveId: state.ttsActiveId === action.id ? null : action.id,
                ttsPaused: false,
            };
        default:
            return state;
    }
};